import { Box } from "@saleor/macaw-ui-next";
import React from "react";

interface SectionHeaderProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  accentColor?: string;
  right?: React.ReactNode;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  icon,
  title,
  description,
  accentColor = "#4F46E5",
  right,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={4}
      marginBottom={5}
      paddingBottom={4}
      style={{ borderBottom: "1px solid rgba(15, 23, 42, 0.08)" }}
    >
      <Box display="flex" alignItems="center" gap={4}>
        {icon && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            __width={36}
            __height={36}
            borderRadius={3}
            style={{
              background: `${accentColor}14`,
              color: accentColor,
            }}
          >
            {icon}
          </Box>
        )}
        <Box>
          <Box
            as="div"
            fontSize={6}
            fontWeight="bold"
            style={{ letterSpacing: "-0.01em", lineHeight: 1.2 }}
          >
            {title}
          </Box>
          {description && (
            <Box as="div" fontSize={2} color="default2" marginTop={1}>
              {description}
            </Box>
          )}
        </Box>
      </Box>
      {right && <Box display="flex" alignItems="center" gap={3}>{right}</Box>}
    </Box>
  );
};
